import React from "react";
import { useLocation } from "react-router-dom";
import { StateAwareNavigate } from "@components/routes/StateAwareNavigate";

export function getIntercompanyTransactionsRedirect(location: {
    search: string;
}): {
    pathname: string;
    search: string;
} {
    return {
        pathname: "/accounting/intercompany-transactions",
        search: location.search,
    };
}

export const LegacyIntercompanyTransactionsRedirect =
    (): React.ReactElement => {
        const location = useLocation();
        return (
            <StateAwareNavigate
                to={getIntercompanyTransactionsRedirect(location)}
                replace
            />
        );
    };
